// extracted by mini-css-extract-plugin
module.exports = {"video":"ImageSlider_video__2kZpV","item":"ImageSlider_item__201ra","skeleton":"ImageSlider_skeleton__1Uhal"};